import errorMessages from "utils/validation/errorMessages";
import { emailSchema } from "utils/validation/validationHelpers";
import { array, number, object, string } from 'yup';

const goalFormSchema = object().shape({
  discipline_id: number().required(errorMessages.required),
  discipline_area: number().required(errorMessages.required),
  title: string().required(errorMessages.required),
  goal_contexts: array().of(
    object().shape({
      context: string().required(errorMessages.required)
    })
  )
});

export default goalFormSchema;